import { render, staticRenderFns } from "./birthCert.vue?vue&type=template&id=64ca1828&scoped=true&"
import script from "./birthCert.vue?vue&type=script&lang=js&"
export * from "./birthCert.vue?vue&type=script&lang=js&"
import style0 from "./birthCert.vue?vue&type=style&index=0&id=64ca1828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca1828",
  null
  
)

export default component.exports